export default __webpack_public_path__ + "static/media/home1.369a3c0c.jpg";